"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _videoViewer = _interopRequireDefault(require("@/directive/video-viewer"));
var _anchor = require("@/api/anchor");
// 工会初审主播
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default,
    VideoViewer: _videoViewer.default
  },
  filters: {
    statusFilter: function statusFilter(val) {
      if (val === 0) {
        val = 'waiting for review'; // 待审核
      } else if (val === 1) {
        // 复审通过
        val = 'adopt';
      } else if (val === 2) {
        val = 'refuse';
      } else if (val === 9) {
        // 工会初审通过(待复审)
        val = 'adopt';
      }
      return val;
    }
  },
  data: function data() {
    return {
      listLoading: false,
      audit: {},
      auditList: [],
      auditTotal: 0,
      auditListQuery: {
        page: 1,
        size: 10,
        status: 0
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$anchorAuthList, code, data, video_arr;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _anchor.anchorAuthList)(this.auditListQuery);
            case 1:
              _yield$anchorAuthList = _context.v;
              code = _yield$anchorAuthList.code;
              data = _yield$anchorAuthList.data;
              this.listLoading = false;
              if (code === 0) {
                video_arr = [];
                data.list.forEach(function (item) {
                  var arr = {};
                  arr.video_see = false;
                  arr.key = item.video_url;
                  video_arr.push(arr);
                });
                localStorage.setItem('video_arr', JSON.stringify(video_arr));
                this.auditList = data.list;
                this.auditTotal = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    updateStatus: function () {
      var _updateStatus = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(row, status) {
        var _this = this;
        var video_arr, video_see, msg;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              // 判断当前视频查看状态
              video_arr = JSON.parse(localStorage.getItem('video_arr'));
              video_see = false;
              video_arr.forEach(function (item) {
                if (item.key === row.video_url && item.video_see === false) {
                  video_see = false;
                } else {
                  video_see = true;
                }
              });
              if (!(video_see === false)) {
                _context3.n = 1;
                break;
              }
              this.$message({
                message: 'You need to check and review her name, profile, and video first, if her video is qualified, then you can Adopt her.',
                type: 'error'
              });
              return _context3.a(2, false);
            case 1:
              msg = this.$t('tips.handleAnchor');
              if (status === 9) msg = this.$t('tips.passAnchor');
              if (status === 2) msg = this.$t('tips.refuseAnchor');
              this.$confirm(msg, this.$t('tips.tips'), {
                confirmButtonText: this.$t('tips.sure'),
                cancelButtonText: this.$t('tips.cancel'),
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
                var _yield$updateAnchorSt, code;
                return (0, _regenerator2.default)().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return (0, _anchor.updateAnchorStatus)({
                        id: row.id,
                        user_id: row.user_id,
                        status: status,
                        remark: row.remark
                      });
                    case 1:
                      _yield$updateAnchorSt = _context2.v;
                      code = _yield$updateAnchorSt.code;
                      if (code === 0) {
                        _this.$message({
                          message: _this.$t('tips.result'),
                          type: 'success'
                        });
                      }
                      _this.getList();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function updateStatus(_x, _x2) {
        return _updateStatus.apply(this, arguments);
      }
      return updateStatus;
    }()
  }
};